<div class="row" style="padding: 15px;">
  <div class="vendor-name-search" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap;">
    <div  style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px;">
      <span style="margin-left: 10px; white-space: nowrap;">Company Code:</span>
      <mat-form-field style="margin-left: 10px;">
        <mat-select placeholder="Select Company Code" [(ngModel)]="searchCompanyCode" name="companyCode">
          <mat-option [value]="''">Select a Company Code</mat-option>
          <mat-option *ngFor="let code of companyCodeValues" [value]="code.companycode">
            {{ code.companycode }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span style="margin-right: 10px; white-space: nowrap;">Vendor ERP Id:</span>
      <mat-form-field>
        <ng-container>
          <input matInput type="text" placeholder="Enter Vendor ERP Id" [(ngModel)]="searchTextVendorERPId"
            name="vendorERPId" required pattern="^[A-Za-z0-9]+$" #fieldRef="ngModel"/> 
        </ng-container> 

        <div *ngIf="fieldRef.invalid && fieldRef.touched" >
          <mat-error *ngIf="fieldRef.errors?.['required']">
            Vendor ERP Id is required.
          </mat-error>
          <mat-error *ngIf="fieldRef.errors?.['pattern']">
            Only letters and numbers are allowed.
          </mat-error> 
        </div>
      </mat-form-field> 
      <button mat-button class="search" (click)="searchData()">Search</button> 
    </div>
    <div>
    <button mat-button class="primary" style="border: 1px solid; border-radius: 3px; height: 32px;" (click)="exportToExcel()"><mat-icon style="margin-right: 5px;">download</mat-icon>Export to Excel</button>
  </div>
  </div>

  <div class="data-not-found" *ngIf="!isDataAvailable">
    No Vendor Classification Details Available
  </div> 

  <div>
    <p-table  *ngIf="isDataAvailable"
    [columns]="columns" 
    [value]="vendorClassification" 
    [paginator]="true" 
    [first]="pageNumber" 
    [rows]="rows"
    [totalRecords]="totalRecords"
    [(selection)]="selectedVendorClassification"
    [sortField]="sortField" 
    [sortOrder]="sortOrder"
    [reorderableColumns]="true" 
    sortMode="multiple" 
    [loading]="isTableLoading"  
    [loadingIcon]="''" 
    [resizableColumns]="true"
    columnResizeMode="expand"
    derableColumns="true" 
    [editable]="true"
    (onPage)="onPageChange($event)"
    [dataKey]="'id'"> 
      <ng-template pTemplate="paginatorright">
        <div class="p-text-right">
          <label for="perPage" class="p-mr-2">Rows per page:</label>
          <select id="perPage" class="p-inputtext" (change)="onRowsChange($event )">
            <option *ngFor="let option of rowsOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns> 
        <tr> 
          <th scope="col">
            <button *ngIf="!isDeleteMode" mat-icon-button color="primary" (click)="addNewRow()" [disabled]="isAnyRowBeingEdited"><mat-icon>add</mat-icon></button>
            <button *ngIf="isDeleteMode" mat-icon-button color="warn" [disabled]="!selectedVendorClassification || selectedVendorClassification.length === 0" (click)="deleteSelectedRows()"><mat-icon>delete</mat-icon></button>
            <button mat-icon-button [color]="isDeleteMode ? 'warn' : 'primary'" (click)="toggleDeleteMode()"><mat-icon>{{ isDeleteMode ? 'close' : 'delete' }}</mat-icon></button>
          </th>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col"> 
            <div class="top-div">
              <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
              <div class="spacer"><p-sortIcon [field]="col.field" /></div>
              <div> 
                <p-columnFilter class="icon-section" [ngClass]="{'active': col.advancefilter.isAdvanceFilterUsed}"
                  #filterRef [type]="col.type" [field]="col.field" display="menu" [showMatchModes]="false" [showOperator]="false"
                  [filterModel]="col.advancefilter"> 
                    <ng-template pTemplate="filter" let-values let-filter="filterCallback" let-index="index"> 
                      <div class="rules-holder" *ngFor="let constraint of col.advancefilter!.constraints; let i = index" >
                        <p *ngIf="i === 0">Show items with value that:</p>
                        <p-dropdown class="p-dropdown" [options]="col.advancefilter!.matchModeOptions" 
                          [(ngModel)]="constraint.matchMode" optionLabel="label"
                          optionValue="value" (change)="onMatchModeChange($event, col.field, i)"/> 
                  
                        <input *ngIf="col.type == 'string' || col.type == 'number'"
                          type="text" pInputText class="p-inputtext"
                          [value]="constraint.value" (input)="onRuleChange($event, col.field, i)"/> 

                        <p-calendar class="p-calendar" *ngIf="col.type == 'date'"
                          [(ngModel)]="constraint.value" [showTime]="true"
                          [hourFormat]="'12'" [showIcon]="true" [placeholder]="'Select date and time'"
                          (onSelect)="onDateRuleChange($event, col.field, i)"></p-calendar>
                          
                        <div class="operator" *ngIf="i === 0" > 
                          <p-dropdown [options]="[
                              { label: 'And', value: 'and' },
                              { label: 'Or', value: 'or' }
                            ]" [(ngModel)]="col.advancefilter.operator"
                            (onChange)="onOperatorChange($event, col.field)" class="p-dropdown">
                          </p-dropdown>
                        </div>
                      </div>

                      <div class="p-d-flex p-jc-end p-ai-center p-gap-2">
                        <button pButton type="button" label="Apply" class="p-button-primary p-button-sm" (click)="applyCall(col, filterRef)">
                        </button>
                        <button pButton type="button" label="Clear" class="p-button-secondary p-button-sm" (click)="clearCall(col, filter, filterRef)">
                        </button>
                      </div>
                    </ng-template> 
                </p-columnFilter>
              </div>
            </div>

            <div class="bottom-div">
              <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false" (onClear)="customClear(col)">
                <ng-template pTemplate="filter">
                  <p-multiSelect [options]="col.filterOptions" 
                    placeholder="Select" [(ngModel)]="filters[col.field]" 
                    [optionLabel]="'label'" appendTo="body" 
                    (onChange)="customFilter(col.type)" [panelStyle]="{'z-index': '1000'}">
                    <ng-template let-option pTemplate="item">
                      <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">{{ option['label'] }}</span>
                      </div> 
                    </ng-template>
                  </p-multiSelect> 
                </ng-template> 
              </p-columnFilter> 

              <button class="clear-button" mat-icon-button *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" 
                (click)="customClear(col)" >
                <mat-icon class="clear-button-icon" >close</mat-icon>
              </button> 
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-i="rowIndex">
        <tr [pSelectableRow]="rowData" [class.selected-row]="selected" [ngClass]="{ 'p-highlight': isSelected( i) }" 
          (click)="onRowClick($event, i)" (mousedown)="onMouseDown($event, i)"
          (mouseover)="onMouseOver($event, i)" (mouseup)="onMouseUp()" (keydown)="onRowKeydown($event, i)" (focus)="onRowFocus($event, i)">
          <td style="text-align: center !important">
            <ng-container *ngIf="isDeleteMode; else editControls">
              <div (mousedown)="$event.stopPropagation()">
                <p-tableCheckbox [value]="rowData" [checked]="selectedIndexes.includes(i)" (click)="onCheckboxClick(i)" (keydown)="onCheckboxClick(i)"></p-tableCheckbox>
              </div>
            </ng-container>
            <ng-template #editControls>
              <ng-container *ngIf="editingVendorInfoRows[i]; else showEditBtn">
                <button mat-icon-button color="primary" (click)="saveRow(i)"><mat-icon>save</mat-icon></button>
                <button mat-icon-button color="warn" (click)="cancelSave(i)"><mat-icon>cancel</mat-icon></button>
              </ng-container>
              <ng-template #showEditBtn>
                <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="editRow(i)" [disabled]="isAnyRowBeingEdited"><mat-icon>edit</mat-icon></button>
              </ng-template>
            </ng-template>
          </td>
          
          <td *ngFor="let col of columns">
            <ng-container>
              <ng-container *ngIf="editingVendorInfoRows[i]; else readOnlyCell"> 
                <ng-container [ngSwitch]="col.type">
                
                  <ng-container *ngSwitchCase="'number'" >
                    <input type="number" pInputText  [placeholder]="'Enter ' + col.title"
                      [(ngModel)]="rowData[col.field]" #fieldRef="ngModel" [disabled]="col.disabled" (mousedown)="$event.stopPropagation()"/> 
                  </ng-container>

                  <!-- Company Code Dropdown -->
                  <ng-container *ngSwitchCase="'companyCodeDropdown'">
                    <p-dropdown
                      [(ngModel)]="rowData[col.field]"
                      [options]="companyCodeValues"
                      optionLabel="companycode"
                      optionValue="companycode"
                      [placeholder]="'Select ' + col.title"
                      [required]="col.required"
                      appendTo="body"
                      #companyCodeRef="ngModel"
                    ></p-dropdown>
                      <div *ngIf="!isCompanyCodeSystemNameValid(rowData)" class="p-error">
                      <span style="white-space: normal;">Selected Company code is not mapped to the selected system.</span>
                    </div>
                  </ng-container>

                  <!-- System name Dropdown -->
                  <ng-container *ngSwitchCase="'systemDropdown'">
                    <p-dropdown
                      [(ngModel)]="rowData[col.field]"
                      [options]="systemNameValues"
                      optionLabel="systemname"
                      optionValue="systemname"
                      [placeholder]="'Select ' + col.title"
                      [required]="col.required"
                      appendTo="body"
                      #fieldRef="ngModel"
                      (onChange)="onSystemNameChange($event, rowData)"
                    ></p-dropdown>
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                  </ng-container>

                  <!-- Vendor Group Dropdown -->
                  <ng-container *ngSwitchCase="'vendorGroupDropdown'">
                    <p-dropdown
                      [(ngModel)]="rowData[col.field]"
                      [options]="vendorGroupValues"
                      optionLabel="vendorGroup"
                      optionValue="vendorGroup"
                      [placeholder]="'Select ' + col.title"
                      [required]="col.required"
                      appendTo="body"
                      #vendorgroupRef="ngModel"
                    ></p-dropdown>
                    <div *ngIf="vendorgroupRef.invalid && (vendorgroupRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="vendorgroupRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                  </ng-container>

                  <!-- Vendor ERP ID Autocomplete -->
                  <ng-container *ngSwitchCase="'autoComplete'">
                    <p-autoComplete
                      [(ngModel)]="rowData[col.field]"
                      [suggestions]="filteredVendors"
                      (completeMethod)="searchVendors($event, col.field)"
                      (onSelect)="onVendorSelect($event, rowData, i)"
                      (ngModelChange)="onVendorInputChange($event, i)"
                      field="vendorERPID"
                      [minLength]="2"
                      [dropdown]="true"
                      [required]="col.required"
                      [placeholder]="'Enter ' + col.title"
                      appendTo="body"
                      (mousedown)="$event.stopPropagation()"
                      #fieldRef="ngModel"
                      [disabled]="!isNewRowBeingEdited && col.disabled"
                    >
                      <ng-template let-item pTemplate="item">
                        <div>{{ item.vendorERPID.trim() }} - {{ item.vendorname.trim() }}</div>
                      </ng-template>
                    </p-autoComplete>
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                    <div *ngIf="rowData[col.field] && rowData[col.field] !== clonedRows[i]?.vendorERPID && !selectedVendors[i] && (fieldRef.dirty || validationTouched[i])" class="p-error">
                      <span style="white-space: normal;">Please select a valid Vendor ERP Id from the list.</span>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'boolean'">
                    <p-dropdown [(ngModel)]="rowData[col.field]" [options]="[
                          { label: 'Yes', value: '1' },
                          { label: 'No', value: '0' }
                        ]"  [placeholder]="'Select ' + col.title"
                      [required]="col.required" appendTo="body" #fieldRef="ngModel">
                    </p-dropdown>
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span *ngIf="fieldRef.errors?.['required']">{{ col.Title }} is required.</span>
                    </div>
                  </ng-container>
                  
                  <ng-container *ngSwitchDefault>
                    <input style="width: -webkit-fill-available;" [required]="col.required"
                      [placeholder]="'Enter ' + col.title" [(ngModel)]="rowData[col.field]" pInputText [required]="col.required"
                      [disabled]="!isNewRowBeingEdited && col.disabled" #fieldRef="ngModel" (mousedown)="$event.stopPropagation()" />
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-template #readOnlyCell>
                <ng-container *ngIf="vendorBooleanColumn.includes(col.field); else otherReadOnlyCells">
                  {{ rowData[col.field] == '1' ? 'Yes' : 'No' }}
                  </ng-container> 
                  <ng-template #otherReadOnlyCells>
                    {{ rowData[col.field] }}
                  </ng-template> 
              </ng-template>
            </ng-container> 
          </td>
        </tr>
      </ng-template>
    </p-table>    
  </div>
</div>